<template>
  <v-container fluid @focus="onUpdateFilters">
    <v-card
      :loading="loading"
      :height="$vuetify.breakpoint.height * 0.9 - 170"
    >
      <v-card-title class="text-center justify-center align-center">Full statistic</v-card-title>
      <v-divider></v-divider>
      <v-card-subtitle ref="RefListTop" height="128">
          <v-container fluid>
                <v-text-field dense type="date" v-model="from_date" clearable label="From" @input="onUpdateFilters()"></v-text-field>
              <v-spacer></v-spacer>
                <v-text-field dense type="date" v-model="to_date" clearable label="To" @input="onUpdateFilters()"></v-text-field>
          </v-container>
        </v-card-subtitle>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <tr><td>Work to be</td><td>{{ getDuration(item.work_to_be) }}</td></tr>
              <tr><td>Work as is</td><td>{{ getDuration(item.work_as_is) }}</td></tr>
              <tr><td>Paid</td><td>{{ getDuration(item.payed) }}</td></tr>
              <tr><td>Bonus</td><td>{{ getDuration(item.extra_time) }}</td></tr>
              <tr><td>Over time</td><td>{{ getDuration(item.over_time) }}</td></tr>
              <tr><td>Holiday</td><td>{{ item.holiday }}</td></tr>
              <tr><td>Holiday extra</td><td>{{ item.holiday_extra }}</td></tr>
              <tr><td>Sick</td><td>{{ item.sick }}</td></tr>
              <tr><td>Sick with child</td><td>{{ item.sick_with_child }}</td></tr>
              <tr><td>Sick KUG</td><td>{{ item.sick_kug }}</td></tr>
              <tr><td>Public holiday</td><td>{{ item.public_holiday }}</td></tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
    <router-view></router-view>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';


export default {
  name: 'CalendarDateUserStatisticRangeOne',
  props: {
    subtractHeight: {type: [Number], default: 120},
    height: {type: [Number], default: window.innerHeight},
    userId: {default: null},
    dto_model: {type: [String], default: 'CalendarDateUserStatisticRangeDTO'},
  },

  components: {
  },

  computed: {
    ...mapGetters('CalendarDateUserStatisticRange', ['getColumns']),
    ...mapFields('CalendarDateUserStatisticRange', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters', 'local_phrase']),
    item() {
      if (this.itemList.length > 0)
        return this.itemList[0]
      else
        return {}
    },
  },

  methods: {
    ...mapActions('CalendarDateUserStatisticRange', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchSaveItemField', 'fetchOrderItemList',
      'fetchActionSelectedItem', 'fetchActionItem']),

    onResize() {
      // this.windowHeight = (window.innerHeight - this.subheight) + 'px'
      // console.log(this.$refs)
      this.windowHeight = (window.innerHeight - this.subtractHeight) + "px"
      // console.log('this.windowHeight', this.windowHeight)
    },

    updateOptions() {
      // console.log('updateOptions', this.userId)
      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    onUpdateFilters() {
      // console.log('updateOptions', this.userId, this.filterEvents, this.startMonth, this.endMonth)
      this.options.page = 1

      this.filters = {}

      if (this.userId !== null)
        this.filters['user_id'] = this.userId

      if (this.from_date) {
        console.log('from_date', this.from_date)
        this.filters['from_date'] = this.from_date + " 00:00:00"
      }
      else
        this.filters['from_date'] = null

      if (this.to_date)
        this.filters['to_date'] = this.to_date + " 23:59:59"
      else
        this.filters['to_date'] = null

      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    getDuration(duration_hours) {
      let abs_duration_hours = Math.abs(duration_hours)
      let hours = Math.floor(abs_duration_hours)
      let minutes = Math.floor(abs_duration_hours * 60) % 60
      if (!duration_hours)
        return '00:00'
      if (duration_hours >= 0)
        return ' ' + String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0')
      else
        return '-' + String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0')
    },
  },

  async mounted() {
    // console.log('mounted')
    this.briefView = this.userId != null
    window.addEventListener("resize", this.onResize)
    this.onResize()
    this.to_date = new Date().toISOString().slice(0, 10)
    this.onUpdateFilters()
  },

  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  beforeDestroy() {
  },

  data() {
    return {
      windowHeight: (this.height - this.subheight) + 'px',
      from_date: null,
      to_date: null,
    }
  }
}
</script>

<style>
.row_even {
  background-color: white !important;
}

.event_working, .event_work_kug {
  background-color: #E3F2FD !important;
}

.event_time_correction {
  background-color: #E1F5FE !important;
}

.event_holiday, .event_holiday_extra {
  background-color: #E8F5E9 !important;
}

.event_sick, .event_sick_with_child, .event_sick_kug {
  background-color: #FFF8E1 !important;
}

.event_error {
  background-color: #FFEBEE !important;
}

</style>
